// extracted by mini-css-extract-plugin
export default {"layoutContainer":"style_layoutContainer__qYrbj","container":"style_container__j-HHr","copyright":"style_copyright__VmErp"};